import React, { useState, useEffect } from 'react'
import { getCompanyDetails, getUserDetails } from '../../../Services/Storage'
import { UpdateDesigncomp } from '../../../Config/api';
import { toast } from 'react-toastify';
import { updatedesignationcomp } from '../../../Slice/designationSlice'
import { Store } from '../../../Store';
import { getRegisterId } from '../../../Config/userId';


const Editdesignation = ({ show, close, editData, updateData }) => {

  const register_id = getRegisterId();
  const userDetails = getUserDetails();
  const company_details = getCompanyDetails();
  const [errors, setErrors] = useState([]);
  const [loader, setloader] = useState((false));

  const [designationadd, setdesignation] = useState({
    designation: '',
    user: register_id,
    edited_by:userDetails.id,
    company: company_details.company_id,
  });

  useEffect(() => {
    if (editData) {
      setdesignation({
        designation: editData.designation,
        user: register_id,
        edited_by:userDetails.id,
      })
    }
  }, [editData, userDetails.id,register_id]);

  const closepop =()=>{
    close();
    setErrors({});
  }
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setdesignation((prev) => ({
      ...prev,
      [name]: value,
    }))
  };

  const handlesubmit = async () => {
    const fieldData = [
      {
        name: "designation",
        type: "input",
        err: "Designation Name",
        conditions: [
          (value) => typeof value === "string",
          (value) => value.trim() !== "",
          (value) => /^[a-zA-Z\s]+$/.test(value),
        ]
      }
    ]
    const fieldOrder = [
      "designation"
    ]
    const newErrors = {};
    for (const fieldName of fieldOrder) {
      const fieldInfo = fieldData.find((field) => field.name === fieldName);
      if (!fieldInfo) {
        continue;
      }
      const fieldType = fieldInfo.type;
      const fieldLabel = fieldInfo.err;
      const value = designationadd[fieldName];
      const isFieldValid = fieldInfo.conditions.every((condition) => typeof condition === "function" ?
        condition
          (value) : condition
      );
      if (!isFieldValid) {
        if (value.trim() === "") {
          newErrors[fieldName] = `${fieldLabel} is required`

        } else {
          newErrors[fieldName] = `Please Enter a Valid ${fieldLabel}.`;

        }
        const inputField = document.querySelector(
          `${fieldType}[name ="${fieldName}"]`

        );
        if (!fieldType) {
          inputField.focus();
          break;
        }
      }
    }
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      try {
        setloader(true)
        const response = await UpdateDesigncomp(editData.id, designationadd);
        if (response) {
          updateData(response.updated_designation);
          Store.dispatch(updatedesignationcomp(response.updated_designation));

          close();
          toast.success('Designation Component Updated Sucessfully!', {
            position: "top-center",
            autoClose: 2000,
            closeButton: false,
            className: 'custom_toast'
          })
        }
      } catch (error) {
        const errorMessage = error.response && error.response.data && error.response.data.data
          ? error.response.data.data.designation
          : "Update Department Failed. Please try again.";

        setErrors((prevErrors) => ({
          ...prevErrors,
          designation: errorMessage,  
        }));

        toast.error("Update Department Failed. Please try again.", {
          position: "top-center",
          autoClose: 2000,
          closeButton: false,
        });
      } finally {
        setloader(false)

      }
    }
  };

  if (!show) return null

  return (
    <div className='popup-section'>
      <div className='popup-container'>
        <span className='uploadexcel-close' onClick={closepop}>&times;</span>

        <div className='popup-container-sub'>
          <div className='addleave-heading'>
            <p>Edit Designation</p>

          </div>

          <div className='addleave-strightline'></div>
          <div className='popup-content-viewing'>
            <div className='popup-inputfield'>
              <div className='popup-inputfield-sub'>
                <label> Designation<span className='registeration-mandatory'> *</span> </label>
                <input className='' value={designationadd.designation} onChange={handleInputChange} name='designation' type='text' />
              </div>
              {errors.designation && (<div className='error-message-view'>{errors.designation}</div>)}
            </div>
            {
              errors.response_error && (
                <div className='error-message-view salry-comp-err'>
                  {errors.response_error.component}
                </div>
              )
            }
            <div className='popup-button'>
              <button onClick={handlesubmit}>{loader ? <span className='spinner'></span> : "Submit"}</button>

            </div>
          </div>
        </div>

      </div>
    </div>

  )
}

export default Editdesignation;